module.exports = __webpack_public_path__ + "static/media/Egress.2125a94d.svg";